<i-modal
  [visible]="!!picture"
  [header]="{ title: 'details.picture' | translate, closable: true }"
  [modalParameters]="{
    isModal: true,
    isMaximizable: true,
    style: { width: '50vw', height: '90vh' },
  }"
  (emitterOnVisibleChange)="close()"
>
  @if (picture) {
    <div class="picture-viewer">
      <div class="picture-viewer__slider">
        <label>{{ "details.brightness" | translate }}</label>
        <p-slider
          [ngModel]="currentBrightness"
          [min]="0"
          [max]="1000"
          (ngModelChange)="updateBrightness($event)"
        />
      </div>

      <div class="picture-viewer__slider">
        <label>{{ "details.zoom" | translate }}</label>
        <p-slider
          [ngModel]="currentZoom"
          [min]="minZoom"
          [max]="maxZoom"
          [step]="zoomStep"
          (ngModelChange)="updateZoom($event)"
        />
      </div>

      <div
        class="picture-viewer__image"
        [class.picture-viewer__image--draggable]="currentZoom > minZoom"
        [class.picture-viewer__image--dragging]="isDragging"
        (wheel)="onImageWheel($event)"
        (mousedown)="onImageMouseDown($event)"
      >
        <img #zoomImage [src]="picture" draggable="false" />
      </div>
    </div>
  }
</i-modal>
